/**
 * useEntities — reporting-entity scope for ESG framework pages.
 * Fetches the entity list once; persists the selection per page so a
 * compliance manager returns to the entity they were working on.
 */
import { useEffect, useState } from "react";
import { apiFetch } from "../components/esg/EsgKit";

export function useEntities(storageKey) {
  const [entities, setEntities] = useState([]);
  const [entityId, setEntityId] = useState(
    () => localStorage.getItem(storageKey) || ""
  );

  useEffect(() => {
    // /api/v1/enterprise/entities is the Postgres-backed list; the bare
    // /api/v1/entities route is the dead Mongo-era enterprise module (500s)
    apiFetch("/api/v1/enterprise/entities")
      .then((r) => {
        const list = r?.entities || [];
        setEntities(list);
        setEntityId((cur) => cur || list[0]?.entity_id || "");
      })
      .catch(() => setEntities([]));
  }, []);

  useEffect(() => {
    if (entityId) localStorage.setItem(storageKey, entityId);
  }, [entityId, storageKey]);

  return { entities, entityId, setEntityId };
}
